import React, {Component} from 'react';
import {Link} from 'react-router';

export default class ProfileCallToAction extends Component {

    render() {
        const {createdAfterCutOff, profile} = this.props;
        if (!profile || !profile.visibility) return null;

        if (createdAfterCutOff) {

            if (profile.visibility.visible === 1) {
                return (<li className="dropdown">
                    <div className="dropdown-toggle">
                        <Link to='/profile'><span>My profile</span></Link>
                    </div>
                </li>)
            }


            return (

                <li className="dropdown padding-top-sph">
                    <Link
                        className="btn btn-primary"
                        data-toggle="collapse"
                        data-target=".in"
                        to='/profile'>
                        <span className="label animated pulse">
                            {(profile.summary && profile.summary.noData === true) || (profile.experience.body && profile.experience.body.length === 0) ? 'Create your profile' : 'Published your profile ?' }
                        </span>
                    </Link>
                </li>
            )
        }


        if (!createdAfterCutOff) {
            if ( (profile.summary && profile.summary.noData === true) || (profile.experience.body && profile.experience.body.length === 0) ) {
                // no need for call to action if you've filled em both but haven't published it

                return (<li className="dropdown padding-top-sph">
                    <Link className="btn btn-primary" data-toggle="collapse"
                          data-target=".in" to='/profile'><span
                        className="label animated pulse">Create your profile</span></Link>
                </li>)
            }

            return (<li className="dropdown">
                <div className="dropdown-toggle">
                    <Link to='/profile'><span>My profile</span></Link>
                </div>
            </li>)
        }

        else return (<li className="dropdown">
            <div className="dropdown-toggle">
                <Link to='/profile'><span>My profile</span></Link>
            </div>
        </li>)

    }
}



// WEBPACK FOOTER //
// src/client/components/common/elements/ProfileCallToAction.js